import React, { Fragment } from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import dayjs from 'dayjs';
import { Title, Text, NoInformation } from '../index';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { StyledCard, StyledCardContent, StyledSummaryCardAction } from './style';

import { SelectedActivityCard, MindgymAppCard } from '../index';

export const SessionSummaryCard = ({
    data,
    title,
    margin,
    $actions,
    $loading,
    bill,
    consultTime,
    style,
    mindgymActivity,
    mdUp,
}) => {
    return (
        <StyledCard
            margin={margin}
            padding={$actions ? '24px 24px 64px 24px' : '24px'}
            style={style}
        >
            <StyledCardContent>
                <Title style={{ fontSize: '16px' }}>{title}</Title>

                {data && !_.isEmpty(data.patient_summaries) ? (
                    <Fragment>
                        {consultTime && (
                            <Fragment>
                                <Text $color="pink" style={{ fontSize: '14px', marginTop: '10px' }}>
                                    Consultation Time
                                </Text>
                                <Text style={{ marginTop: '10px' }}>
                                    {data?.patient_summaries[0].joinTime
                                        ? dayjs(data?.patient_summaries[0].joinTime).format(
                                              'DD MMMM YYYY, HH:mm'
                                          )
                                        : '-'}
                                </Text>
                            </Fragment>
                        )}
                        {data?.patient_summaries[0]?.noteToPatient && (
                            <Fragment>
                                <Text $color="pink" style={{ fontSize: '14px', marginTop: '10px' }}>
                                    Note from Provider
                                </Text>
                                <Text style={{ marginTop: '10px' }}>
                                    {data?.patient_summaries[0]?.noteToPatient}
                                </Text>
                            </Fragment>
                        )}

                        {data?.patient_summaries[0]?.homework && (
                            <Fragment>
                                <Text $color="pink" style={{ fontSize: '14px', marginTop: '10px' }}>
                                    Homework
                                </Text>
                                <Text style={{ marginTop: '10px' }}>
                                    {data?.patient_summaries[0]?.homework}
                                </Text>
                            </Fragment>
                        )}

                        {!_.isEmpty(mindgymActivity) && (
                            <div>
                                <Text $color="pink" style={{ fontSize: '14px', marginTop: '10px' }}>
                                Friday Homework
                                </Text>
                                <div
                                    style={{
                                        marginTop: '10px',
                                        display: 'grid',
                                        gridTemplateColumns: mdUp ? 'auto auto' : 'auto',
                                        columnGap: '24px',
                                        rowGap: mdUp ? '16px' : '10px',
                                        overflow: 'hidden',
                                    }}
                                >
                                    {mindgymActivity.map((item) => (
                                        <SelectedActivityCard
                                            key={`selected-activity-${item.type}`}
                                            data={item}
                                            padding={mdUp ? '15px 19px 19px 19px' : '10px'}
                                        />
                                    ))}
                                </div>
                                <MindgymAppCard mdUp={mdUp} />
                            </div>
                        )}
                    </Fragment>
                ) : (
                    <NoInformation />
                )}
            </StyledCardContent>
            {$actions && (
                <StyledSummaryCardAction $loading={$loading}>
                    <div
                        style={{
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'space-between',
                            paddingLeft: '20px',
                            paddingRight: '20px',
                        }}
                    >
                        <Text $color="white">Total</Text>
                        <Text $color="white">
                            {$loading ? 'Summarizing expenses...' : `THB ${bill}`}
                        </Text>
                    </div>
                </StyledSummaryCardAction>
            )}
        </StyledCard>
    );
};

SessionSummaryCard.propTypes = {
    data: PropTypes.object,
    title: PropTypes.string,
    margin: PropTypes.string,
    $actions: PropTypes.bool,
    $loading: PropTypes.bool,
    bill: PropTypes.number,
    consultTime: PropTypes.bool,
    style: PropTypes.object,
};

export const NoteFromProviderCard = ({ data, style }) => {
    return (
        <StyledCard style={style}>
            <StyledCardContent>
                <Title style={{ fontSize: '16px' }}>Note from Provider</Title>
                <Text $color="pink" style={{ fontSize: '14px', marginTop: '10px' }}>
                    Diagnosis
                </Text>
                <Text style={{ marginTop: '10px' }}>{data?.patient_summaries[0]?.diagnosis}</Text>

                <Text $color="pink" style={{ fontSize: '14px', marginTop: '10px' }}>
                    Treatment
                </Text>
                <Text style={{ marginTop: '10px' }}>{data?.patient_summaries[0]?.treatment}</Text>
            </StyledCardContent>
        </StyledCard>
    );
};

NoteFromProviderCard.propTypes = {
    data: PropTypes.object,
    style: PropTypes.object,
};
